var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0501 35.85C40.6601 36.12 40.2101 36.45 39.6901 36.85C36.8801 38.85 27.3701 45.55 17.3401 45.74C19.2699 46.2428 21.2558 46.4982 23.2501 46.5C28.4737 46.506 33.5456 44.7437 37.6401 41.5C39.1074 39.8371 40.2626 37.9231 41.0501 35.85Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 37.33C42.3749 36.5042 42.946 35.6391 43.4599 34.74C43.3327 34.7038 43.1992 34.6949 43.0682 34.7139C42.9372 34.7328 42.8118 34.7792 42.7 34.85C42.4203 35.6973 42.0863 36.5257 41.7 37.33H41.75Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7501 29.15C43.6639 30.5967 43.4463 32.0326 43.1001 33.44C43.431 33.3502 43.7823 33.3713 44.1001 33.5C45.2746 31.1179 46.0258 28.5496 46.3201 25.91C45.6067 27.1018 44.7355 28.1916 43.7301 29.15H43.7501Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.26 22.27C43.5955 23.9363 43.773 25.6304 43.79 27.33C44.9608 26.4726 45.8879 25.3249 46.48 24C46.48 23.74 46.48 23.48 46.48 23.22C46.4799 21.0413 46.1736 18.8735 45.57 16.78C45.3639 18.7939 44.5514 20.6978 43.24 22.24L43.26 22.27Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9101 20.72C44.3101 19.56 44.9601 17.09 44.4301 13.66C42.5864 9.58805 39.608 6.13389 35.8516 3.71121C32.0952 1.28852 27.72 9.07713e-06 23.2501 0C22.7001 0 22.1501 0 21.6101 0.06C32.2701 1.68 40.3201 10.64 42.9101 20.72Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2101 16.29C33.5501 21.92 36.8501 23.08 41.4001 21.47C37.8801 7.13001 25.2701 0.440009 16.6601 1.00001C11.5288 2.51878 7.07844 5.76115 4.06006 10.18C8.06006 9.29001 11.6101 10.42 23.2101 16.34V16.29Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6301 43.46C26.0001 42.76 36.8701 36.7 38.2801 36C38.9001 35.69 40.2801 34.66 41.6401 34C41.9679 32.7561 42.1755 31.4836 42.2601 30.2C40.4601 31.2 37.8501 31.92 33.2601 32.91C26.5101 34.8 12.2601 36.91 0.310059 26.71C0.848919 30.3172 2.22847 33.747 4.33732 36.7227C6.44617 39.6984 9.22521 42.1364 12.4501 43.84C17.1801 44.84 18.7401 44.66 23.6301 43.46Z",
    fill: "#C9082A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.51 31.49C35.9085 30.88 39.2064 29.8031 42.31 28.29C42.2973 27.243 42.2205 26.1977 42.08 25.16C42.01 24.55 41.91 23.96 41.81 23.37C39.63 24.55 36.22 24.71 30.81 22.76C25.18 20.09 12.37 11.5 6.88003 11.5C5.67163 11.3175 4.44454 11.2939 3.23003 11.43C1.10941 15.0076 -0.0064795 19.0912 2.83025e-05 23.25C2.83025e-05 23.81 2.83048e-05 24.37 0.0700283 24.92C4.56003 29.78 18.59 35.38 32.51 31.49Z",
    fill: "#C9082A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f23c82c0c840af0cc01f4eeaf6f587f.svg";
export { ForwardRef as ReactComponent };